import P from '@hero/ui-kit/typography/P';
import React from 'react';
import type { TestimonialBlock as TestimonialBlockType } from '../../../types';
import renderTextWithVariables from '../renderTextWithVariables';

const TestimonialBlock: React.FC<{ block: TestimonialBlockType }> = ({ block }) => {
    // BE shows the star row whenever stars is set (0 renders five empty stars).
    const stars = block.stars == null ? null : Math.min(5, Math.max(0, Math.trunc(block.stars)));
    return (
        <blockquote
            style={{
                margin: '1.2rem 0',
                padding: '1.2rem 1.6rem',
                borderLeft: '4px solid #f26c3a',
                backgroundColor: '#fafafa'
            }}
        >
            {stars !== null && (
                <div style={{ marginBottom: '0.4rem', color: '#f5a623' }}>
                    {'★'.repeat(stars)}
                    {'☆'.repeat(5 - stars)}
                </div>
            )}
            <P styles={{ margin: '0 0 0.8rem', fontStyle: 'italic', fontSize: '1.1em' }}>
                "{renderTextWithVariables(block.quote)}"
            </P>
            {(block.source || block.byline) && (
                <footer style={{ fontSize: '0.9em', color: '#666' }}>
                    {block.source && <strong>{block.source}</strong>}
                    {block.source && block.verified && (
                        <span style={{ marginLeft: '0.4rem', color: '#28a745' }} title="Verified">
                            ✓
                        </span>
                    )}
                    {block.source && block.byline && ' — '}
                    {block.byline && <span>{block.byline}</span>}
                </footer>
            )}
        </blockquote>
    );
};
export default TestimonialBlock;
